import React, { useState } from "react";
import { Form, Formik } from "formik";
import { Button, TextBox } from "../..";
import background from "../../../assets/admin/signIn/background.jpg";
import { ReactComponent as EmailSvg } from "../../../assets/icons/email.svg";
import { ReactComponent as LockSvg } from "../../../assets/icons/lock.svg";
import { ReactComponent as ArrowRightSvg } from "../../../assets/icons/arrow-right.svg";
import useAuth from "../../../hooks/useAuth";
import PropTypes from "prop-types";
import { toast } from "react-toastify";

const AdminLogin = ({ onSignIn }) => {
  const { adminSignIn } = useAuth();
  const [error, setError] = useState("");

  const handleSignIn = async (username, password) => {
    try {
      const token = await adminSignIn(username, password);
      onSignIn(token);
    } catch (error) {
      setError("Invalid username or password");
      toast.error("Invalid username or password");
    }
  };

  return (
    <div className="admin-login">
      <img className="admin-login-background" src={background} />
      <div className="admin-login-form">
        <div className="admin-login-form-content">
          <h1 className="admin-login-form-content__header">Login</h1>
          <Formik
            initialValues={{
              username: "",
              password: "",
            }}
            validate={({ username, password }) => {
              const errors = {};
              if (!username) {
                errors.username = "Invalid username";
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              const { username, password } = values;
              setSubmitting(true);
              handleSignIn(username, password);
              setSubmitting(false);
            }}
          >
            {({ values: { username, password }, errors }) => {
              return (
                <Form className="">
                  <TextBox
                    name="username"
                    label="Username"
                    placeholder="Username"
                    type="text"
                    leadingIcon={<EmailSvg />}
                    values={username}
                  />
                  <TextBox
                    name="password"
                    label="Password"
                    placeholder="Password"
                    type="password"
                    leadingIcon={<LockSvg />}
                    values={password}
                  />
                  <Button
                    type="submit"
                    label="LOGIN"
                    trailingIcon={<ArrowRightSvg />}
                    style={{ margin: "40px 0", width: "300px" }}
                  />
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

AdminLogin.propTypes = {
  onSignIn: PropTypes.func,
};

AdminLogin.defaultProps = {
  onSignIn: () => {},
};

export default AdminLogin;
